import { gql } from 'apollo-angular';

export const GET_VEHICLE_MANUFACTURERS = gql`
  query GetVehicleManufacturers($input: VehicleManufacturerSearchInput!) {
    vehicleManufacturers(input: $input) {
      top {
        id
        name
      }
      popular {
        id
        name
      }
      all {
        id
        name
      }
    }
  }
`;
